<template>
  <el-dialog
    title="选择商品"
    :visible.sync="visible"
    width="960px"
    append-to-body
    @closed="handleClosed">
    <div
      v-loading="loading"
      class="product-transfer-wrap">
      <el-transfer
        v-model="ruleForm.multipleSelection"
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入商品名称"
        :titles="['未选择', '已选择']"
        :data="ruleForm.list"
        :props="prop"
      ></el-transfer>
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="addItem">确定</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
function noop() {}
export default {
  name: 'ProductMutiSelectModal',
  props: {
    callback: {
      type: Function,
      default: noop
    },
    prop: {
      type: Object,
      default() {
        return {
          key: 'productId',
          label: 'productName'
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: {
        list: [],
        multipleSelection: []
      },
      config: {
        pageNum: 1,
        pageSize: 100000
      }
    }
  },
  methods: {
    filterMethod(query, item) {
      return item[this.prop.label].indexOf(query) > -1
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.$set(this, 'ruleForm', {
        list: [],
        multipleSelection: []
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.ruleForm.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(ids) {
      this.fetchList(() => {
        this.ruleForm.multipleSelection = ids
        this.toggleModal(true)
      })
    },
    addItem() {
      const result = this.ruleForm.multipleSelection
      if (result.length === 0) {
        this.$message.error('请至少选择一个商品')
        return
      }
      const key = this.prop.key
      const list = this.ruleForm.list.filter(i => result.indexOf(i[key]) > -1)
      this.toggleModal(false)
      this.callback && this.callback(list)
    }
  }
}
</script>
<style lang="stylus">
.product-transfer-wrap {
  .el-transfer {
    height: 560px;

    .el-transfer-panel {
      width: 365px;
      height: 100%;

      .el-transfer-panel__body {
        height: calc(100% - 40px);

        .el-transfer-panel__list {
          height: calc(100% - 62px);
        }
      }
    }
  }
}
</style>
